import { render, staticRenderFns } from "./PsConnect.vue?vue&type=template&id=9d4c25c4&scoped=true&"
import script from "./PsConnect.vue?vue&type=script&lang=js&"
export * from "./PsConnect.vue?vue&type=script&lang=js&"
import style0 from "./PsConnect.vue?vue&type=style&index=0&id=9d4c25c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4c25c4",
  null
  
)

export default component.exports